import React from "react";
import { ArrowRight, Sparkles, MoveDown } from "lucide-react";
import { BRAND } from "@/constants/brand";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 -z-10">
        <img
          src={BRAND.heroBgUrl}
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-[#FAFAFA]/92" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FAFAFA] via-[#FAFAFA]/80 to-[#FAFAFA]" />
        <div className="absolute inset-0 bg-grid-lines opacity-60" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8 ifx-rise">
            <div className="inline-flex items-center gap-2 border border-[#E2E8F0] bg-white/70 backdrop-blur px-3 py-1.5 rounded-full">
              <Sparkles className="h-3.5 w-3.5 text-[#0055FF]" />
              <span className="uppercase text-[11px] tracking-[0.22em] font-bold text-[#0B1120]">
                {BRAND.slogan}
              </span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display mt-7 text-5xl sm:text-6xl lg:text-7xl tracking-tight font-black text-[#1B2A6E] leading-[1.02]"
            >
              Digital Transformation,<br />
              <span className="text-[#0B1120]">engineered for Indian SMEs.</span>
            </h1>

            <p
              data-testid="hero-subhead"
              className="mt-7 text-lg md:text-xl text-[#475569] leading-relaxed max-w-2xl"
            >
              Enterprise SaaS, agentic AI workflows, modern data infrastructure
              and a full‑stack growth practice — under one accountable partner.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                onClick={() => scrollTo("#contact")}
                data-testid="hero-primary-cta"
                className="group inline-flex items-center gap-2 bg-[#1B2A6E] text-white hover:bg-[#152259] px-7 py-4 rounded-sm text-sm font-semibold tracking-wide transition-colors"
              >
                Book a free consultation
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </button>
              <button
                onClick={() => scrollTo("#services")}
                data-testid="hero-secondary-cta"
                className="group inline-flex items-center gap-2 bg-transparent text-[#1B2A6E] border border-[#1B2A6E] hover:bg-[#1B2A6E] hover:text-white px-7 py-4 rounded-sm text-sm font-semibold tracking-wide transition-colors"
              >
                Explore services
                <MoveDown className="h-4 w-4 transition-transform group-hover:translate-y-0.5" />
              </button>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-2xl">
              <Stat label="Faster cycle times" value="40%+" />
              <Stat label="Average CAC reduction" value="28%" />
              <Stat label="Audit‑ready by default" value="100%" />
            </div>
          </div>

          <div className="lg:col-span-4 lg:pl-8 hidden lg:block">
            <div className="border border-[#E2E8F0] bg-white p-7 rounded-sm shadow-sm">
              <p className="uppercase text-[11px] tracking-[0.22em] font-bold text-[#0055FF]">
                Why Infolocus
              </p>
              <p className="mt-3 font-display text-2xl font-bold text-[#0B1120] leading-tight">
                One team for SaaS, AI, data and demand.
              </p>
              <ul className="mt-5 space-y-3 text-sm text-[#475569]">
                <li className="flex gap-2"><span className="text-[#0055FF]">—</span> Outcome‑led delivery</li>
                <li className="flex gap-2"><span className="text-[#0055FF]">—</span> SME‑first pricing</li>
                <li className="flex gap-2"><span className="text-[#0055FF]">—</span> Built for Bharat ops</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ value, label }) => (
  <div data-testid={`hero-stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="font-display text-3xl md:text-4xl font-black text-[#1B2A6E] leading-none">
      {value}
    </div>
    <div className="mt-2 text-xs uppercase tracking-[0.18em] text-[#475569] font-semibold">
      {label}
    </div>
  </div>
);
